import { PrimaryText } from "@/shared/ui/Typography";

export const EmptyPlanBlock = () => (
    <PrimaryText fontSize={14} fontWeight="400" style={{ textAlign: "center" }}>
        План продажів не встановлено
    </PrimaryText>
);
